import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  View,
  FlatList,
  Image,
  ActivityIndicator,
} from "react-native";
import { useNavigation } from "@react-navigation/native";
import Text from "@components/AppText";
import colors from "@constants/color";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import { getSkuOrdersDetails } from "@services/api";

const SkuOrdersDetails = ({ route }) => {
  const navigation = useNavigation();
  const [ordersData, setOrdersData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { order_ids = [], title = "" } = route?.params || {};

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    try {
      const { data } = await getSkuOrdersDetails({ order_ids });
      setOrdersData(data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
    setIsLoading(false);
  };
  const renderItem = ({ item }) => {
    return (
      <View style={styles.cardContainer}>
        <View style={styles.card}>
          <View style={styles.imageContainer}>
            {item?.product_image ? (
              <Image
                source={{ uri: item.product_image }}
                style={styles.productImage}
                resizeMode="contain"
              />
            ) : (
              <View style={styles.placeholderImage} />
            )}
          </View>
          <View style={styles.infoContainer}>
            <Text style={styles.productName} numberOfLines={2}>
              {item?.product_name}
            </Text>
          </View>
          <View style={styles.qtyContainer}>
            <Text style={styles.qtyText}>{item?.quantity || 0}</Text>
          </View>
        </View>
      </View>
    );
  };

  const keyExtractor = (item, index) => `${item?.sku_id}-${index}`;

  return (
    <View style={{ flex: 1 }}>
      <HeaderWithBackAndTitle
        headertitle={title}
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        route={route}
      />
      {isLoading ? (
        <View style={styles.loadingView}>
          <ActivityIndicator size="large" color={colors.primary} />
        </View>
      ) : (
        <FlatList
          data={ordersData?.items || []}
          renderItem={renderItem}
          keyExtractor={keyExtractor}
          contentContainerStyle={styles.containerStyle}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  containerStyle: {
    paddingHorizontal: 10,
    paddingTop: 12,
    paddingBottom: 8,
  },
  cardContainer: {
    marginBottom: 8,
  },
  card: {
    flexDirection: "row",
    backgroundColor: colors.white,
    borderRadius: 12,
    padding: 10,
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.06)",
    alignItems: "center",
  },
  imageContainer: {
    backgroundColor: colors.white,
    borderRadius: 12,
    borderWidth: 0.5,
    borderColor: "rgba(0, 0, 0, 0.10)",
    padding: 8,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 12,
  },
  productImage: {
    width: 60,
    height: 60,
  },
  placeholderImage: {
    width: 60,
    height: 60,
    backgroundColor: "rgba(0, 0, 0, 0.04)",
    borderRadius: 8,
  },
  qtyContainer: {
    backgroundColor: "rgba(0, 0, 0, 0.06)",
    borderRadius: 8,
    minWidth: 36,
    height: 36,
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 8,
    paddingHorizontal: 8,
  },
  qtyText: {
    fontSize: 16,
    fontFamily: "NotoSansDevanagari-Bold",
    color: colors.mediumBlack,
    lineHeight: 24,
    textAlign: "center",
  },
  infoContainer: {
    flex: 1,
    justifyContent: "center",
  },
  productName: {
    fontSize: 12,
    lineHeight: 20,
    color: colors.mediumBlack,
    fontFamily: "NotoSansDevanagari-Regular",
  },
  loadingView: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    backgroundColor: colors.white,
  },
});

export default SkuOrdersDetails;
